<!--<div class="rounded-circle text-white" style="min-height: 1rem; min-width: 1rem" [ngClass]="backgroundColorClass">-->
@switch (messageStatus) {
  @case ('DISABLED') {
    <span class="fa fa-light fa-circle-minus ps-2 pe-1 py-2 text-muted"></span>
  }
  @case ('UNKNOWN') {
    <span class="fa fa-light fa-circle-question ps-2 pe-1 py-2"></span>
  }
  @case ('PENDING') {
    <span class="fa fa-light fa-paper-plane ps-2 pe-1 py-2 text-info"></span>
  }
  @case ('DELIVERED') {
    <span class="fa fa-light fa-inbox ps-2 pe-1 py-2 text-portbase-green"></span>
  }
  @case ('ACCEPTED') {
    <span class="fa fa-light fa-circle-check ps-2 pe-1 py-2 text-portbase-green"></span>
  }
  @case ('WARNING') {
    <span class="fa fa-light fa-comment-exclamation ps-2 pe-1 py-2 text-warning"></span>
  }
  @case ('DEADLINE_CLOSE') {
    <span class="fa fa-light fa-clock-nine ps-2 pe-1 py-2 text-warning"></span>
  }
  @case ('REJECTED') {
    <span class="fa fa-light fa-circle-xmark ps-2 pe-1 py-2 text-portbase-red"></span>
  }
  @case ('DEADLINE_MISSED') {
    <span class="fa fa-light fa-clock-twelve ps-2 pe-1 py-2 text-warning"></span>
  }
}
<!--</div>-->
